import React from 'react';
interface EmptyTabProps {
  message: string;
}
export const EmptyTab: React.FC<EmptyTabProps> = ({ message }) => {
  return (
    <div className="mt-8 mb-3 flex items-center justify-center">
      <div className="w-75">
        <h2 className="text-blue-light">{message}</h2>
      </div>
    </div>
  );
};
